import React from 'react'
import { clsx } from 'clsx'
import styles from './GridGrid.module.scss'
import type { PartialWidgetContext } from '@/types/cms'
import Partials from '@/elements/Partials'
import AppContext from '@/types/context'

export interface GroupGridFlexProps {
  children: Array<PartialWidgetContext>
  model: {
    fields: {
      columns: 1 | 2 | 3 | 4
      device: 'all' | 'mobile' | 'desktop'
    }
  }
}

const GridGrid = ({ item, context }: { item: GroupGridFlexProps; context: AppContext }) => {
  return (
    <div className={clsx(styles.container, styles[`cols-${item.model?.fields?.columns ?? 3}`])}>
      {item.children.map((widget: PartialWidgetContext, index) => {
        return <Partials key={index} context={context} item={widget as any} />
      })}
    </div>
  )
}

export default GridGrid
